<template>
    <div class="pdf-viewer">
		<div class="pdf-viewer__header">
			<div class="h-logo">
		        <router-link class="h-logo-link" :to="'/'">
		            <span class="icon"></span>
		        </router-link>
		    </div>
		</div>

		<div class="viewer-container viewer-backdrop viewer-fixed viewer-hooper viewer-fade viewer-in" ref="viewer"
             @keyup.space="slideNext">

            <div class="viewer-canvas-wrapper">

                <div class="viewer-canvas" :class="{'nav-hovered-prev': hoveredPrev, 'nav-hovered-next': hoveredNext}">
                    <hooper @slide="slide" class="carousel-thumbs viewer-carousel" ref="viewerHooper" :infiniteScroll="true">

                        <slide :key="index"
                               v-for="(item,index) in files">
                          <div class="item">
                    			<iframe width="840" height="1200" :src="item.link" frameborder="0"></iframe>
                                <div class="inner-nav" v-if="files.length > 1">
                                    <div class="prev" @click="slidePrev" @mouseover="hoveredPrev = true" @mouseleave="hoveredPrev = false"></div>
                                    <div class="next" @click="slideNext"  @mouseover="hoveredNext = true" @mouseleave="hoveredNext = false"></div>
                                </div>
                          </div>
                        </slide>
                        <hooper-navigation slot="hooper-addons" v-if="files.length > 1"></hooper-navigation>
                    </hooper>
                </div>
                <div class="photo-num">
                    {{currentSlide}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
	import {Hooper, Slide, Navigation as HooperNavigation} from 'hooper'; // carousel

    export default {
        name: "PdfViewer",
        components: {
			Hooper,
            Slide,
            HooperNavigation,
        },
        data() {
            return {
                btnType: 'normal',
				currentSlide: 1,
				currentSlidePrev: 1,
				hoveredPrev: false,
				hoveredNext: false,
				isShowedViewer: false,
            }
        },
        props: {
            files: []
        },
		mounted(){
            if(this.$route.params.number > 1){
                this.$refs.viewerHooper.slideTo(this.$route.params.number)
            }
			this.$refs.viewer.querySelector('.hooper-track').focus();
		},
        methods: {
			slideNext() {
                this.$refs.viewerHooper.slideNext();
            },
            slidePrev() {
                this.$refs.viewerHooper.slidePrev();
            },
			slide(payload){
                this.currentSlide = +payload.currentSlide == -1 ? this.files.length : +payload.currentSlide +1;
                if(this.files && +this.currentSlide > this.files.length){
                    this.currentSlide = 1;
                }
                this.currentSlidePrev = +payload.slideFrom
            },
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                item: state => state.rules.openedRule,
                topSections: state => state.rules.topSections,
            }),
        }
    }
</script>

<style scoped>

</style>
